import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { get, size } from 'lodash-es';
import Table from '../../components/Table';
import Loading from '../../components/Loading';
import CollapseButton from '../../components/CollapseButton';
import { API_HOST } from '../../consts';

class EncomendasFluxoTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.startCollapsed,
      fetchingElaboradores: true,
      elaboradores: [],
      entregas: [],
      data: {}
    };
  }

  componentDidMount() {
    const { collapsed } = this.state;
    if (!collapsed) {
      this.fetchElaboradores();
    }
  }

  componentDidUpdate(_, prevState) {
    const { collapsed } = this.state;
    if (prevState.collapsed && !collapsed) {
      this.fetchElaboradores();
    }
  }

  get itensEntregues() {
    const elaboradores = get(this.state, 'data.elaboradores', []);
    return elaboradores.reduce(this.reduceItensEntregues, 0);
  }

  get pageSize() {
    const length = get(this.state, 'data.elaboradores.length');
    const maxPageSize = 20;
    return length > maxPageSize ? maxPageSize : length;
  }

  fetchElaboradores() {
    const { encomenda } = this.props;
    axios
      .get(`${API_HOST}/encomenda/itens_por_status/elaborador`, {
        params: {
          encomenda: get(encomenda, 'id')
        }
      })
      .then((response) => {
        this.setState({
          data: response.data,
          fetchingElaboradores: false
        });
      });

    this.fetchItensVinculados();
  }

  fetchItensVinculados() {
    const { encomenda, getItensVinculados } = this.props;
    axios
      .get(`${API_HOST}/encomenda/item`, {
        params: { encomenda: encomenda.id }
      })
      .then((response) => {
        const itensVinculados = response.data.map((d) => d.id);
        getItensVinculados(itensVinculados);
      });
  }

  reduceItensEntregues(acc, el) {
    const statuses = { ...get(el, 'statuses', {}) };
    delete statuses[1];
    return (
      acc + Object.values(statuses).reduce((acc2, value) => acc2 + value, 0)
    );
  }

  get columns() {
    const { handleVerMais } = this.props;
    const statuses = get(this.state, 'data.statuses', []);
    return [
      {
        Header: 'Nome',
        accessor: 'nome'
      },
      ...statuses.map((status) => ({
        Header: status.descricao,
        accessor: `statuses.${status.id}`,
        Cell: (row) => row.value || 0
      })),
      {
        Header: 'Ações',
        filterable: false,
        Cell: (row) => (
          <button onClick={() => handleVerMais(row)} className="btn btn-white">
            <i className="fas fa-eye" />
          </button>
        )
      }
    ];
  }

  fetchItensVinculados() {
    const { encomenda, getItensVinculados } = this.props;
    axios
      .get(`${API_HOST}/encomenda/item`, {
        params: { encomenda: encomenda.id }
      })
      .then((response) => {
        const itensVinculados = response.data.map((d) => d.id);
        getItensVinculados(itensVinculados);
      });
  }

  handleCollapse = () => {
    const { collapsed } = this.state;
    this.setState({ collapsed: !collapsed });
  };

  render() {
    const { data, fetchingElaboradores, collapsed } = this.state;
    const { elaboradores } = data;
    const { handleVincularItens, encomenda } = this.props;

    return (
      <Fragment key={get(encomenda, 'id')}>
        <div className="container">
          <div className="professores-first">
            <div className="row">
              <div className="col-11">
                <p className="subtitle">Áreas de Conhecimento</p>
                <div className="col-md-12 d-flex">
                  {encomenda &&
                    encomenda.areas_conhecimento.map((d) => (
                      <p>{d.descricao}</p>
                    ))}
                </div>
              </div>
              <div className="col-1">
                <CollapseButton
                  collapsed={collapsed}
                  onClick={this.handleCollapse}
                />
              </div>
            </div>
            {!collapsed && fetchingElaboradores && <Loading />}
            {!collapsed && !fetchingElaboradores && (
              <Fragment>
                <hr />
                <div className="row">
                  <div className="col-4 pb-3">
                    <button
                      className="btn primary-button"
                      onClick={handleVincularItens}
                    >
                      VINCULAR ITENS
                    </button>
                  </div>
                  <div className="offset-4 col-2">
                    <p className="subtitle">Itens Solicitados:</p>
                    <p>{get(encomenda, 'total_itens_encomenda')}</p>
                  </div>
                  <div className="col-2">
                    <p className="subtitle">Itens Entregues:</p>
                    <p>{this.itensEntregues}</p>
                  </div>
                  <div className="col-md-12">
                    <Table
                      showPageSizeOptions={false}
                      pageSize={size(elaboradores)}
                      filterable
                      data={elaboradores}
                      columns={this.columns}
                    />
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

EncomendasFluxoTab.propTypes = {
  pedido: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  startCollapsed: PropTypes.bool,
  handleVincularItens: PropTypes.func.isRequired,
  handleVerMais: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

EncomendasFluxoTab.defaultProps = {
  startCollapsed: true
};

export default withRouter(EncomendasFluxoTab);
